import { DMA } from "../model/DMA";
import { printCalculationError, convertToMegaLitresPerDay, round } from "../helper/helper";

export const getTotalSupply = (
  data: {}[], 
  date: string, 
  dmaCodes: DMA[]
) => {
  
  let sum: number = 0;

  data.forEach(object => {
    let dma: any = Object.values(object)[0];
    dmaCodes.forEach((e) => {
      if (e.name === dma.polygon_description && e.selected === true) {
        let index: number = dma.supply.dates.indexOf(date);
        let value: number = parseFloat(dma.supply.values[index]);

        if (!isNaN(value)) {
          sum += value;
        } else {
          printCalculationError("Supply", date, value);
        }
      }
    });
  });

  return convertToMegaLitresPerDay(sum, date);
};

export const getTotalSupplyData = (data: any) => {
  let totalSupplydata = data.map((dma: {}) => {
    let dmaData: any = Object.values(dma)[0];

    return {
      x: dmaData.supply.dates,
      y: dmaData.supply.values.map((num: number, index: number) => { 
        let dateTemp = dmaData.non_revenue_water.dates[index]; 
        return Math.round(convertToMegaLitresPerDay(num, dateTemp) * 100)/ 100}),
      type: "bar",
      name: dmaData.polygon_description,
      selected: true,
    };
  });

  return totalSupplydata;
};
